import React from 'react';
import Support from './Support';
import { ModuleProps } from 'types';
import getRoutes from './routes';
import RouteModuleFactory from '../@layout/Router/RouteModuleFactory';

const routes = getRoutes();

const SupportModule: React.FC<ModuleProps> = appRouteProps => {
  return <RouteModuleFactory IndexComponent={Support} routes={routes} {...appRouteProps} />;
};

export default SupportModule;
